// extracted by mini-css-extract-plugin
export var bg = "Hero-module--bg--HTd3B";
export var date = "Hero-module--date--F+O0P";
export var heroContainer = "Hero-module--heroContainer--kFALV";
export var shadow = "Hero-module--shadow--ixBc7";
export var title = "Hero-module--title--u-KCJ";